import React from 'react';
import {useState, useEffect} from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

class Person {
    constructor(id, name, age, occupation, healthConditions) {
        this.id = id;
        this.name = name;
        this.age = age;
        this.occupation = occupation;
        this.healthConditions = healthConditions;
        this.priority = this.priorityValue();
    }
    priorityValue() {
        let value = 0;
        let highRiskJobs = {'doctor': 10, 'dentist': 10, 'nurse': 10, 'cashier': 7, 'teacher': 7, 'professor': 7, 'EMT': 10};
        const agePriority = (age) => {
            let priority = 0;
            if (age > 100) priority += 10;
            else if (age > 65 && age < 100) priority += 8;
            else if (age > 40 && age < 65) priority += 6;
            else if (age > 20 && age < 40) priority += 4;
            else priority += 2;
            return priority;
        }
        if (!(this.job in highRiskJobs)) value += 5;
        else value += highRiskJobs[this.job];
        value += agePriority(this.age);
        if (this.healthConditions) value += 10;
        return value - this.id;
    }
}

const Title = styled.div`
    font-size: 150%;
    font-family: Courier;
    margin: auto 0;
`; 

const Page = styled.div`
    background-color: beige;
    width: 100%;
    height: 100vh;
`;
const Container = styled.div`
    width: 100%;
    padding: 5%;
    display: flex;ß
`;

const InputBox = styled.div`
    width: 90%;
    height: 50%;
    display: flex;
    margin: auto 0;
    background-color: white;
`;

const Input = styled.div`
    width: 20%;
    padding: 2%;
    margin: auto;
`;

const Inp = styled.input`
    width: 70%;
`;

const Line = styled.div`
    padding: 3%;
    margin: auto 0;
`;

const Enter = styled.button`
    padding: 2%;
    font-size: 100%;
    background-color: black;
    font-family: Courier;
    color: white;
`;

const Header = () => {
    return (
        <>
        <Container id="header">
            <Title>COVID Vaccine Priority Queue</Title>
        </Container>
        </>
    );
}

const Queue = () => {
    const [PQ, setPQ] = useState([]);
    const [id, setId] = useState(1);
    
    const fetchInfo = () => {
        const ID = id;
        setId(id => id + 1);
        const name = document.getElementById("name").value;
        const age = document.getElementById("age").value;
        const job = document.getElementById("job").value;
        const health = document.getElementById("health").value;
        return health == 'yes' ? new Person(id, name, age, job, true) : new Person(id, name, age, job, false);
    }
    const enqueue = () => {
        let newPerson = fetchInfo();
        let updatedPQ = [newPerson, ...PQ];
        let sortedPQ = updatedPQ.sort((a, b) => {
            return a.priority - b.priority;
        });
        console.log('update: ', updatedPQ);
        console.log('sort: ', sortedPQ);
        setPQ(sortedPQ);
    }
    const dequeue = () => {
        let newPQ = PQ.slice(0, PQ.length - 1);
        setPQ(newPQ);
    }
    return (
        <>
        <Container id="input">
            <InputBox>
                <Input>Name<br></br>
                    <Inp id="name"></Inp>
                </Input>
                <Input>Age<br></br>
                    <Inp id="age"></Inp>
                </Input>
                <Input>Occupation<br></br>
                    <Inp id="job"></Inp>
                </Input>
                <Input>Has Health Conditions<br></br>
                    <Inp id="health"></Inp>
                </Input>
                <Enter onClick={enqueue}>Enqueue</Enter>
                <Enter onClick={dequeue}>Vaccinate Next</Enter>
            </InputBox>
        </Container>
        <Container id="queue">
            {PQ.map((person) => <Line key={person.id.toString()}>{person.name}</Line>)}
        </Container>
        </>
    );
}

const App = () => {
    
    return (
        <>
        <Page>
            <Header/>
            <Queue/>
        </Page>
        </>
    );
}

export default App;